export default "__VITE_ASSET__BlGQNvpF__"